import { CoordinatesService } from './cadastro-services/coordinates-service';
import { CadasterDataService } from './cadastro-services/cadaster-data-service';
import { Idealista } from './pricing-services/idealista';

export class LinkBuilder {

    private cadastralReference: string;
    private coordinatesService: CoordinatesService;
    private cadasterDataService: CadasterDataService;

    public get ConstructionElements(): { lcd: string; stl: number }[] {
        if (this.cadasterDataService.success) {
            return this.cadasterDataService.data.lconsElements;
        } else return null;
    }

    public get Province():string{
        if (this.cadasterDataService.success) {
            return this.cadasterDataService.data.province;
        } else return "";
    }

    public get Municipality():string{
        if (this.cadasterDataService.success) {
            return this.cadasterDataService.data.municipality;
        } else return "";
    }

    public get FullAddress():string{
        if (this.cadasterDataService.success) {
            return this.cadasterDataService.data.fullAddress;
        } else return "";
    }

    private constructor(cadastralReference: string, coordinatesService: CoordinatesService, catastroInfo: CadasterDataService) {
        this.cadastralReference = cadastralReference;
        this.coordinatesService = coordinatesService;
        this.cadasterDataService = catastroInfo;
    }

    static async fetchData(cadastralReference: string): Promise<LinkBuilder> {
        const refC = cadastralReference.toString().toUpperCase();
        console.log(refC);

        // Get coordinates (assuming this still returns null if not found)
        const coords = await CoordinatesService.getCoordinatesByRefCat(refC);

        // Get cadaster data (new discriminated union)
        const cadasterResult = await CadasterDataService.getCadasterData(refC);

        return new LinkBuilder(
            refC,
            coords,
            cadasterResult
        );
    }

    getGoogleStreetViewLink(): string {
        if (this.coordinatesService.success) {
            return `https://www.google.com/maps?q=${this.coordinatesService.data.lat},${this.coordinatesService.data.lng}`;
        }
        else {
            return this.coordinatesService.error;
        }
    }

    getCadasterInfoLink(): string {
        if (this.cadasterDataService.success) {
            return `https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCConCiud.aspx?UrbRus=U&RefC=${this.cadastralReference}&esBice=&RCBice1=&RCBice2=&DenoBice=&from=OVCBusqueda&pest=rc&RCCompleta=${this.cadastralReference}&final=&del=${this.cadasterDataService.data.codigoProvincia}&mun=${this.cadasterDataService.data.codigoMunicipio}`;
        }
        else {
            return this.cadasterDataService.error;
        }
    }

    getIdealistaLink(): string {
        if (this.cadasterDataService.success && this.coordinatesService.success) {
            return `${Idealista.buildIdealistaUrl(this.coordinatesService.data.lat, this.coordinatesService.data.lng, this.cadasterDataService.data.sumSqmVivienda)}`;
        }
        else {
            return `Cadaster service error: ${this.cadasterDataService.error} Coordinates service error: ${this.coordinatesService.error}`
        }
    }

    getLat(): string {
        if (this.coordinatesService.success) {
            return this.coordinatesService.data.lat.toString();
        }
        else {
            return this.coordinatesService.error;
        }
    }

    getLng(): string {
        if (this.coordinatesService.success) {
            return this.coordinatesService.data.lng.toString();
        }
        else {
            return this.coordinatesService.error;
        }
    }
}